import React from 'react';

const Html = ({ children }: any) => {
  return <div dangerouslySetInnerHTML={{ __html: children }} />;
};

export default Html;
